export default __webpack_public_path__ + "static/media/wsb-community.58cc742d.png";